export interface DataItem {
  id?: string;
  [key: string]:
    | string
    | number
    | boolean
    | null
    | undefined
    | Date
    | Record<string, unknown>
    | Array<Record<string, unknown>>
    | unknown;
}

export interface Editor {
  label: string;
  value: string;
}

// Business
export * from "./business/address";
export * from "./business/company";
export * from "./business/distributor";
export * from "./business/equipment";
export * from "./business/freight";
export * from "./business/job";
export * from "./business/job-task";
export * from "./business/job-department";

// Cart
export * from "./orders/cart";

// Cloudinary
export * from "./cloudinary/cloudinary";

// Core
export * from "./core/audit-log";
export * from "./core/auth";
export * from "./core/cookie";
export * from "./core/permissions";

// Editor
export * from "./editor/blocks";

// Orders
export * from "./orders/orders";
export * from "./orders/cart";

// Products
export * from "./products/brand";
export * from "./products/pricing-tier";
export * from "./products/product";
export * from "./products/product-group";
export * from "./products/tags";
export * from "./products/attributes";
export * from "./products/product-parent";

// Response
export * from "./response";

// Vehicles
export * from "./vehicles/vehicle-brand";
export * from "./vehicles/vehicle-group";
export * from "./vehicles/vehicle-model";
export * from "./vehicles/vehicle-type";
export * from "./vehicles/company-fleet";
export * from "./vehicles/user-fleet";
export * from "./vehicles/company-vehicle";
export * from "./vehicles/user-vehicle";

export interface CountryData {
  id: number;
  name: string;
  iso2: string;
  iso3: string;
  emoji: string;
  phone_code: string;
}

export interface StateData {
  id: number;
  name: string;
  country_code: string;
  state_code: string;
}

export interface PlaceResult extends google.maps.places.PlaceResult {
  name?: string;
  address_components?: Array<{
    long_name: string;
    short_name: string;
    types: string[];
  }>;
}

export interface AppFile {
  id: string;
  name: string;
  url: string;
  type: string;
  size: string;
  dateAdded: Date;
}

// Communication types
export * from "./communication/contact";
export * from "./communication/enquiries";
export * from "./communication/feedback";

// Backup types
export * from "./backups/neon";

export * from "./response";
